module.exports = __webpack_public_path__ + "static/media/kiwi2.0dfdb961.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/kiwi2.png
// module id = 39
// module chunks = 0